import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9c6b9pvwy: FaireProductEntity = {
  token: "p_f9c6b9pvwy",
  type: "product",
  name: "Heart necklace, bracelet, earrings set in PVD stainless steel, waterproof",
  brandToken: "b_3t5pew5dxb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3701066baa05e4160e2839a02e75721774d75a7f69b8c5e7ed7915592a18aac2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/086a8cf0913ec2a2b2f2680e4273d566f5c9f6681789a59b639ddb7f63e5099a.jpeg",
    "https://cdn.faire.com/fastly/4aa8d8787944e6948f521bf1c0f4de3941c82d2fe6def6f666ca1cf93c941025.jpeg",
    "https://cdn.faire.com/fastly/126b4e88a1238656f2ff9d2f4747bdfa0b2d0df971ab8ef2f81076fa157f881f.jpeg",
    "https://cdn.faire.com/fastly/7ccd178950f691ce831b0c13b0f635d0fe0d822068fcf7ccf1bd317a513fae83.jpeg",
  ],
  priceDollars: 9.58,
  description:
    "The price includes the necklace, bracelet and a pair of premium quality stainless steel earrings\n\nPremium Material: Stainless steel with 18K vacuum gold plating (PVD Waterproof); water-resistant, durable and does not fade.\nFinish: High-polish shine with cubic zirconia\nNecklace length: approximately 40 cm plus 6 cm adjustable extension\nBracelet length: approximately 15 cm plus 6 cm adjustable extension\n\nStock in Spain: Fast shipping and no customs.\n\nDirect Price: Luxury look at factory price.",
  tags: [],
  msrpDollars: 19.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:36.584Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
